import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import settingsIcon from '@assets/images/menu-settings-icon.svg'
import helpCenterIcon from '@assets/images/menu-help-icon.svg'
import logoutIcon from '@assets/images/menu-logout-icon.svg'

import { UserBadge } from '@components/UserBadge'
import { DropDownAction, Action } from '@components/DropDownAction'

import { useSignOut } from '@hooks/auth/sign-out.hook'
import { useMe } from '@hooks/user/me.hook'

import { Container } from './LoggedUser.styled'

const URL_HELP_CENTER = 'https://toolkit-app.notion.site/Centre-d-aide-ba028ac5f90b41fc9725c9a2efa20071?pvs=4'

export const LoggedUser = (): JSX.Element => {
  const { t } = useTranslation()

  const { signOut } = useSignOut()

  const { i18n } = useTranslation()

  const navigate = useNavigate()

  const { getMe } = useMe()
  const user = getMe()

  const actions: Action[] = [
    {
      key: 'settings',
      label: t('modules_main_pages_main_label_settings'),
      Icon: () => <img src={settingsIcon} />,
    },
    {
      key: 'help_center',
      label: t('modules_main_pages_main_label_help_center'),
      Icon: () => <img src={helpCenterIcon} />,
    },
    {
      key: 'logout',
      label: t('modules_main_pages_main_label_sign-out'),
      Icon: () => <img src={logoutIcon} />,
    },
  ]

  const onClickAction = (action: Action) => {
    if (action.key == 'help_center') {
      window.open(URL_HELP_CENTER, '_blank')
    } else if (action.key == 'settings') {
      const path = `/${i18n.language}/settings/my_account`
      navigate(path)
    } else if (action.key == 'logout') {
      signOut()
    }
  }

  return (
    <DropDownAction
      mask="light"
      sections={[{ key: '', actions }]}
      onClickAction={onClickAction}
      WrappedComponent={() => <Container>{<UserBadge user={user} displayLabel />}</Container>}
    />
  )
}
